import React from 'react';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-container">
      <div className="footer-info">
        <h4>Postresitos & Café</h4>
        <p>© 2025 Todos los derechos reservados</p>
      </div>
      <div className="footer-contact">
        <a href="tel:+59179397892" className="contact-link">
          📞 +591 79397892
        </a>
        <a href="mailto:pizarroapaza.alisonbelen@gmail.com" className="contact-link">
          ✉️ Email
        </a>
        <a href="https://www.whatsapp.com/?lang=es_LA" className="contact-link" target="_blank" rel="noopener noreferrer">
          💬 WhatsApp
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
  